import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#1a1a2e] border-t border-white/10 py-10 px-6 text-center" data-id="element-47">
        <div className="max-w-[720px] mx-auto" data-id="element-48">
          <p className="font-sans text-sm text-white/50 mb-3" data-id="element-49">
            © {new Date().getFullYear()} Programa Desinflàmate 65+. Todos los
            derechos reservados.
          </p>
          <p className="font-sans text-xs text-white/30 mb-6" data-id="element-50">
            Este producto no sustituye el consejo médico profesional.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-51">
            <button onClick={() => setActiveModal('privacy')} className="font-sans text-sm text-white/40 hover:text-white underline underline-offset-2 transition-colors" data-id="element-52">
              Política de Privacidad
            </button>
            <span className="text-white/20" data-id="element-53">|</span>
            <button onClick={() => setActiveModal('terms')} className="font-sans text-sm text-white/40 hover:text-white underline underline-offset-2 transition-colors" data-id="element-54">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-55">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" onClick={() => setActiveModal(null)} data-id="element-56">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.25
        }} className="bg-cream rounded-2xl shadow-xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-57">
              {/* Modal Header */}
              <div className="flex items-center justify-between border-b border-sage/20 px-6 py-4" data-id="element-58">
                <h2 className="font-serif text-xl text-forest font-medium" data-id="element-59">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="rounded-full p-2 text-charcoal/50 hover:text-forest hover:bg-sage/10 transition-colors" data-id="element-60">
                  <XIcon className="w-5 h-5" data-id="element-61" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-charcoal/80 font-serif text-base leading-relaxed space-y-6" data-id="element-62">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-63" /> : <TermsContent data-id="element-64" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-charcoal/50 font-sans" data-id="element-65">
        Última actualización: Enero 2026
      </p>

      <div data-id="element-66">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-67">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-68">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital. Esto incluye tu nombre,
          dirección de correo electrónico y datos de pago. No almacenamos
          información de tarjetas de crédito en nuestros servidores.
        </p>
      </div>

      <div data-id="element-69">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-70">
          2. Uso de la Información
        </h3>
        <p data-id="element-71">Tu información personal se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-72">
          <li data-id="element-73">Procesar y confirmar tu compra</li>
          <li data-id="element-74">Enviarte el acceso al producto digital</li>
          <li data-id="element-75">Proporcionarte soporte técnico si lo necesitas</li>
          <li data-id="element-76">Enviarte actualizaciones del producto que has adquirido</li>
        </ul>
      </div>

      <div data-id="element-77">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-78">
          3. Protección de Datos
        </h3>
        <p data-id="element-79">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Utilizamos cifrado SSL para
          todas las transmisiones de datos.
        </p>
      </div>

      <div data-id="element-80">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-81">
          4. Compartir Información
        </h3>
        <p data-id="element-82">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. La única excepción son los proveedores de servicios de pago
          necesarios para procesar tu transacción, quienes están obligados a
          mantener la confidencialidad de tu información.
        </p>
      </div>

      <div data-id="element-83">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-84">
          5. Cookies
        </h3>
        <p data-id="element-85">
          Utilizamos cookies esenciales para el funcionamiento del sitio web. No
          utilizamos cookies de seguimiento publicitario ni compartimos datos de
          navegación con terceros.
        </p>
      </div>

      <div data-id="element-86">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-87">
          6. Tus Derechos
        </h3>
        <p data-id="element-88">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. También puedes solicitar una copia de
          todos los datos que tenemos sobre ti. Para ejercer estos derechos,
          puedes contactarnos a través de los canales indicados en el producto.
        </p>
      </div>

      <div data-id="element-89">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-90">
          7. Cambios en esta Política
        </h3>
        <p data-id="element-91">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Cualquier cambio será publicado en esta página con
          la fecha de actualización correspondiente.
        </p>
      </div>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-charcoal/50 font-sans" data-id="element-92">
        Última actualización: Enero 2026
      </p>

      <div data-id="element-93">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-94">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-95">
          Al acceder y utilizar este producto digital "Protocolo
          Anti-Inflamatorio 65+", aceptas estar sujeto a estos términos y
          condiciones. Si no estás de acuerdo con alguna parte de estos
          términos, no debes utilizar este producto.
        </p>
      </div>

      <div data-id="element-96">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-97">
          2. Producto Digital
        </h3>
        <p data-id="element-98">
          Este es un producto digital de carácter informativo y educativo. El
          contenido no sustituye el consejo médico profesional, diagnóstico o
          tratamiento. Siempre consulta con tu médico u otro profesional de la
          salud calificado antes de realizar cambios en tu dieta o estilo de
          vida.
        </p>
      </div>

      <div data-id="element-99">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-100">
          3. Licencia de Uso
        </h3>
        <p data-id="element-101">
          Al realizar la compra, se te otorga una licencia personal, no
          transferible y no exclusiva para acceder y utilizar el contenido del
          protocolo. Esta licencia es únicamente para tu uso personal y no
          permite:
        </p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-102">
          <li data-id="element-103">Reproducir o distribuir el contenido a terceros</li>
          <li data-id="element-104">Utilizar el contenido con fines comerciales</li>
          <li data-id="element-105">Modificar o crear obras derivadas del contenido</li>
          <li data-id="element-106">Compartir tu acceso con otras personas</li>
        </ul>
      </div>

      <div data-id="element-107">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-108">
          4. Política de Reembolso
        </h3>
        <p data-id="element-109">
          Ofrecemos una garantía de devolución de 30 días. Si no estás
          satisfecha con el producto, puedes solicitar un reembolso completo
          dentro de los 30 días posteriores a la compra, sin necesidad de
          justificación. El reembolso se procesará por el mismo método de pago
          utilizado en la compra original.
        </p>
      </div>

      <div data-id="element-110">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-111">
          5. Propiedad Intelectual
        </h3>
        <p data-id="element-112">
          Todo el contenido del "Protocolo Anti-Inflamatorio 65+", incluyendo
          textos, recetas, ilustraciones, diseño y estructura, está protegido
          por derechos de autor. Queda prohibida su reproducción total o parcial
          sin autorización expresa por escrito.
        </p>
      </div>

      <div data-id="element-113">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-114">
          6. Limitación de Responsabilidad
        </h3>
        <p data-id="element-115">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos derivados del uso de este protocolo. En ningún
          caso seremos responsables por daños directos, indirectos, incidentales
          o consecuentes derivados del uso o la imposibilidad de uso de este
          producto.
        </p>
      </div>

      <div data-id="element-116">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-117">
          7. Modificaciones
        </h3>
        <p data-id="element-118">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación. El uso continuado del producto después de cualquier
          modificación constituye la aceptación de los nuevos términos.
        </p>
      </div>

      <div data-id="element-119">
        <h3 className="font-sans font-bold text-forest text-lg mb-3" data-id="element-120">
          8. Ley Aplicable
        </h3>
        <p data-id="element-121">
          Estos términos se regirán e interpretarán de acuerdo con las leyes
          vigentes. Cualquier disputa que surja en relación con estos términos
          será sometida a la jurisdicción de los tribunales competentes.
        </p>
      </div>
    </>;
}